import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=6d7d181a&scoped=true&"
import script from "./NotFound.vue?vue&type=script&lang=js&"
export * from "./NotFound.vue?vue&type=script&lang=js&"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=6d7d181a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7d181a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TextWithIcon: require('/home/bitrix/frontend/components/other/TextWithIcon.vue').default})
